import React, { useContext, useEffect, useRef, useState } from "react";
import ItemSelectBox2 from "../../forms/ItemSelectBox2.js";
import axios from "axios";
import { distance } from "fastest-levenshtein";
import Swal from "sweetalert2";
import ReactDOM from "react-dom";

export default function DeliveryModal(props) {
  const { onClose, token, deliveryList, invoiceData, setRefetch, refetch } = props;
  console.log("invoiceData inside delivery modal............", invoiceData)
  const [deliveryFormData, setDeliveryFormData] = useState({
    deliveryName: invoiceData.delivery_method.type_name ?? "",
    deliveryId: invoiceData.delivery_method.id ?? "",
    companyName: "",
    companyId: "",
    customerName: invoiceData.customer_name ?? "",
    customerAddress: invoiceData.delivery_customer_address ?? "",
    customerPhone: invoiceData.customer_phone ?? "",
    deliveryCustomerName: invoiceData.delivery_customer_name ?? "",
    deliveryCustomerAddress: invoiceData.delivery_customer_address ?? "",
    deliveryCustomerPhone: invoiceData.delivery_customer_phone ?? "",
    deliveryFee: invoiceData.delivery_fee ?? "",
    parcel_type: "",
    delivery_area: "",
    note: invoiceData.delivery_note ?? "",
  });

  console.log("deliveryList........", deliveryList)

  useEffect(() => {
    if (deliveryList?.length) {
      // console.log(deliveryList);
      let selectInitial = deliveryList.find(
        (item) => (item?.type_name).toLowerCase() == "pathao"
      );
      setDeliveryFormData({
        ...deliveryFormData,
        deliveryId: selectInitial?.id,
        deliveryName: selectInitial?.type_name,
      });
    }
  }, [deliveryList]);
  useEffect(()=>{console.log(deliveryFormData)},[deliveryFormData])
  const handleChangeSelect = (name, option) => {
    const { value, label } = option; //some error in this code.
    setDeliveryFormData({
      ...deliveryFormData,
      deliveryId: value,
      deliveryName: label,
    });
  };


  const [pathaoStores, setPathaoStores] = useState([]);
  const [pathaoStore, setPathaoStore] = useState({
    store_id: "",
    store_name: "Select store",
  });
  const getPathaoStoreList = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}pathao/stores`, {
        headers: {
          authorization: `Bearer ${token} `,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("Pathao Stores... ", response.data.data.data);
        setPathaoStores(response.data.data.data);
        setPathaoStore({
          store_id: response.data.data.data[0].store_id,
          store_name: response.data.data.data[0].store_name
        })
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (deliveryFormData?.deliveryName?.toLowerCase() === "pathao")
      getPathaoStoreList();
  }, [deliveryFormData?.deliveryName]);

  const handlePathaoStoreChangeSelect = (name, option) => {
    const { value, label } = option; //some error in this code.

    setPathaoStore({
      store_id: value,
      store_name: label,
    });
  };

  const normalize = (str) =>
    str
      ?.toLowerCase()
      .replace(/[^a-z0-9\s]/gi, "")
      .trim() || "";
  const tokenize = (str) => normalize(str).split(/\s+/);

  //FOR CITIES
  const tokenBasedCityMatch = (address, cities) => {
    const addressTokens = tokenize(address);

    for (const city of cities) {
      const cityTokens = tokenize(city.city_name);
      const commonTokens = cityTokens.filter((token) =>
        addressTokens.includes(token)
      );

      if (commonTokens.length >= 1) {
        return city.city_id;
      }
    }

    return null;
  };

  const fuzzyCityMatch = (address, cities) => {
    const normalizedAddress = normalize(address);

    let bestMatch = null;
    let smallestDistance = Infinity;

    for (const city of cities) {
      const d = distance(normalize(city.city_name), normalizedAddress);

      if (d < smallestDistance && d < 8) {
        smallestDistance = d;
        bestMatch = city.city_id;
      }
    }

    return bestMatch;
  };

  //FOR ZONES
  const normalizeNoSpaces = (str) =>
  normalize(str).replace(/\s+/g, "");

  // Step 1: Token-based smart match
  const tokenBasedMatch = (address, zones) => {
    const addressNoSpaces = normalizeNoSpaces(address);

    for (const zone of zones) {
      const zoneNoSpaces = normalizeNoSpaces(zone.zone_name);
      if (addressNoSpaces.includes(zoneNoSpaces) || zoneNoSpaces.includes(addressNoSpaces)) {
        return zone.zone_id;
      }
    }
    return null;
  };

  // Step 2: Fuzzy fallback match
  const fuzzyMatch = (address, zones) => {
    const normalizedAddress = normalizeNoSpaces(address);

    let bestMatch = null;
    let smallestDistance = Infinity;

    for (const zone of zones) {
      const normalizedZone = normalizeNoSpaces(zone.zone_name);
      const d = distance(normalizedZone, normalizedAddress);
      if (d < smallestDistance && d <= 2) {
        smallestDistance = d;
        bestMatch = zone.zone_id;
      }
    }
    return bestMatch;
  };

  const [pathaoCities, setPathaoCities] = useState([]);
  const [pathaoCity, setPathaoCity] = useState({
    city_id: "",
    city_name: "Select city",
  });
  const getPathaoCityList = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}pathao/cities`, {
        headers: {
          authorization: `Bearer ${token} `,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("Pathao Cities... ", response.data.data.data);
        setPathaoCities(response.data.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getMatchedCityId = (address, cities, deliveryDistrict) => {
    if (!cities?.length) return null;

    // STEP 1: If delivery district exists, match directly
    if (deliveryDistrict) {
      const matchedDistrict = cities.find(
        (city) =>
          city.city_name?.toLowerCase().trim() ===
          deliveryDistrict.toLowerCase().trim()
      );

      if (matchedDistrict) return matchedDistrict.city_id;
    }

    // STEP 2: If address missing, return null
    if (!address) return null;

    // STEP 3: Fallback to original matching logic
    return (
      tokenBasedCityMatch(address, cities) ?? fuzzyCityMatch(address, cities)
    );
  };

  useEffect(() => {
    if (deliveryFormData?.deliveryName?.toLowerCase() === "pathao")
      getPathaoCityList();
  }, [deliveryFormData?.deliveryName]);

  useEffect(() => {
    if (
      invoiceData?.delivery_customer_address &&
      deliveryFormData?.deliveryName?.toLowerCase() === "pathao"
    ) {
      const matchedCityId = getMatchedCityId(
        invoiceData.delivery_customer_address,
        pathaoCities,
        invoiceData?.delivery_district
      );
      const matchedCity = pathaoCities.find((c) => c.city_id === matchedCityId);

      if (matchedCity) {
        setPathaoCity(matchedCity); // this triggers getPathaoZoneList
      }
    }
  }, [
    invoiceData?.delivery_customer_address,
    pathaoCities,
    deliveryFormData?.deliveryName,
    invoiceData?.delivery_district
  ]);

  const handlePathaoCityChangeSelect = (name, option) => {
    const { value, label } = option; //some error in this code.

    setPathaoCity({
      city_id: value,
      city_name: label,
    });
  };

  const [pathaoZones, setPathaoZones] = useState([]);
  const [pathaoZone, setPathaoZone] = useState({
    zone_id: "",
    zone_name: "Select zone",
  });
  const getPathaoZoneList = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}pathao/zones/${pathaoCity?.city_id}`,
        {
          headers: {
            authorization: `Bearer ${token} `,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        console.log("Pathao Zones... ", response.data.data.data);
        setPathaoZones(response.data.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (
      deliveryFormData?.deliveryName?.toLowerCase() === "pathao" &&
      pathaoCity.city_id !== ""
    )
      getPathaoZoneList();
  }, [pathaoCity.city_id]);

  useEffect(() => {
    if (
      pathaoZones.length &&
      invoiceData?.delivery_customer_address &&
      deliveryFormData?.deliveryName?.toLowerCase() === "pathao"
    ) {
      const matchedZoneId = getMatchedZoneId(
        invoiceData.delivery_customer_address,
        pathaoZones,
        invoiceData?.delivery_city
      );
      const matchedZone = pathaoZones.find((z) => z.zone_id === matchedZoneId);

      if (matchedZone) {
        setPathaoZone({
          zone_id: matchedZone.zone_id,
          zone_name: matchedZone.zone_name,
        });
      }
    }
  }, [
    pathaoZones,
    invoiceData?.delivery_customer_address,
    deliveryFormData?.deliveryName,
    invoiceData?.delivery_city
  ]);

  const handlePathaoZoneChangeSelect = (name, option) => {
    const { value, label } = option; //some error in this code.

    setPathaoZone({
      zone_id: value,
      zone_name: label,
    });
  };

  const getMatchedZoneId = (address, zones, deliveryCity) => {
    if (!zones?.length) return null;

    // STEP 1: If delivery city exists → try direct match with zone_name
    if (deliveryCity) {
      const matchedZone = zones.find(
        (zone) =>
          zone.zone_name?.toLowerCase().trim() ===
          deliveryCity.toLowerCase().trim()
      );

      if (matchedZone) return matchedZone.zone_id;
    }

    // STEP 2: If no address, return null
    if (!address) return null;

    // STEP 3: Fallback to original match logic
    return tokenBasedMatch(address, zones) ?? fuzzyMatch(address, zones);
  };

  const [loading, setLoading] = useState(false);
  const loadingCallback = (loading) => {
    setLoading(loading);
  };

  const handleSubmitOrder = async () => {

    const transformedProductArray = invoiceData.sales_details.map((item, index) => ({
      product_id: item?.product_id,
      qty: item.qty,
      product_variant_id: item?.product_variant_id
        ? item?.product_variant_id
        : null,
      price: item.price,
      retails_price: item?.product_info?.retails_price ?? 0,
      mode: 1,
      size: 1,
      sales_id: item.sales_id,
      imei_id: item?.imei_id || "",
      purchase_price: item?.purchase_price ?? 0 ,
      sale_price: item?.sale_price ?? 0,
      wholesale_price: item?.wholesale_price,
      color: item?.color ?? "",
      color_code: item?.color_code ?? "",
      note: item?.note ?? "",
      storage: item?.storage ?? "",
      battery_life: item?.battery_life ?? "",
      region: item?.redgion ?? "",
      image_path: item?.image_path ?? "",
      product_condition: item?.product_condition ?? "",
    }));

    const totalPrice = transformedProductArray.reduce((total, item) => {
      const itemTotalPrice = item.qty * item.price;
      return total + itemTotalPrice;
    }, 0);

    const paymentMap = invoiceData?.multiple_payments?.map((item) => ({
      payment_type_id: item.payment_type_id,
      payment_type_category_id: item.payment_type_category_id,
      payment_amount: item?.payment_amount
        ? item?.payment_amount
        : item?.Amount
        ? item?.Amount
        : 0,
    }))

    const data = {
      invoice_id: invoiceData?.invoice_id,
      pay_mode: invoiceData?.pay_mode,
      paid_amount: Number(invoiceData?.paidAmount),
      cash_change: parseInt(invoiceData?.cashChange),
      sub_total: totalPrice,
      vat: invoiceData?.vat,
      tax: invoiceData?.tax,
      discount: Number(invoiceData?.discount),
      product: transformedProductArray,
      delivery_method_id: deliveryFormData.deliveryId,
      delivery_info_id: deliveryFormData.deliveryId,
      delivery_customer_name: deliveryFormData.deliveryCustomerName,
      delivery_customer_address: deliveryFormData.deliveryCustomerAddress,
      delivery_customer_phone: deliveryFormData.deliveryCustomerPhone,
      delivery_fee: deliveryFormData.deliveryFee,
      delivery_note: deliveryFormData.note ?? "",
      payment_method: paymentMap,
      sales_id: 1,
      status: 0,
      created_at: invoiceData?.created_at,
      //warranty: defaultWarrantyList,
    };

    data.customer_id = invoiceData?.customer_id;
    data.customer_name = invoiceData?.customer_name;
    data.customer_phone = invoiceData?.customer_phone;

    data.sales_id =  invoiceData?.sales_id;

    data.status = 1;

    const url = "update-ecommerce-sales";

    await axios
      .post(`${process.env.REACT_APP_API_URL}${url}`, data, {
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(async (response) => {
        loadingCallback(false);
        console.log("response.data.success... ", response.data.success);
        if (response.data.success) {
          console.log("response.data?.data?.invoice_id... ", response.data?.data?.invoice_id);
          const invoice_id = response.data?.data?.invoice_id ?? invoiceData.invoice_id ?? null;
          const sale_id = response.data?.data?.sales_id ?? null;
        //----------------------------------------------------PATHAO BLOCK-------------------------------
          if (
            deliveryFormData?.deliveryName?.toLowerCase() === "pathao" && invoice_id
          ) {
              const namesString = {
                names: invoiceData?.sales_details
                  ?.map((item) => {
                    const baseName = item.product_info?.name || item.name || "Unnamed Product";
                    const variantName =
                      item.product_variant_id && item.product_variant?.name
                        ? ` (${item.product_variant.name})`
                        : "";

                    const qtySuffix = item.qty > 1 ? ` x${item.qty}` : ""; // add quantity if > 1

                    return baseName + variantName + qtySuffix;
                  })
                  .filter(Boolean)
                  .join(", "),
              };
              console.log("namestring.........", namesString)
              const totalQty = invoiceData?.sales_details?.reduce(
                (sum, item) => sum + (item?.qty || 0),
                0
              );

              console.log("🚀 ~ handleSubmitOrder ~ totalQty:", totalQty)
              const totalPriceInvoice = transformedProductArray.reduce((total, item) => {
                const itemTotalPrice = item?.qty * item?.price;
                return total + itemTotalPrice;
              }, 0);

              const due = totalPriceInvoice + invoiceData.delivery_fee;

              const pathaoOrder = {
                store_id: pathaoStore.store_id,
                merchant_order_id: invoice_id,
                recipient_name: deliveryFormData?.deliveryCustomerName,
                recipient_phone: deliveryFormData?.deliveryCustomerPhone,
                recipient_address: deliveryFormData?.deliveryCustomerAddress,
                recipient_city: pathaoCity.city_id,
                recipient_zone: pathaoZone.zone_id,
                special_instruction: deliveryFormData?.note ?? "",
                item_quantity: totalQty,
                item_description: namesString.names,
                amount_to_collect: Math.round(Number(due)),
              };
              console.log(
                "Pathao ",
                invoice_id,
                " Due ",
                Math.round(Number(due))
              );

              await axios
                .post(
                  `${process.env.REACT_APP_API_URL}pathao/create-order`,
                  pathaoOrder,
                  {
                    headers: {
                      authorization: `Bearer ${token}`,
                      "Content-Type": "application/json",
                    },
                  }
                )
                .then(async (response) => {
                  console.log("✅ Order placed successfully:", response.data);
                  const steadFastOrderResponse = {
                    consignment_id: response.data?.data?.consignment_id,
                    invoice: invoice_id,
                    sale_id: sale_id,
                    recipient_name: deliveryFormData?.deliveryCustomerName,
                    recipient_phone: deliveryFormData?.deliveryCustomerPhone,
                    recipient_address: deliveryFormData?.deliveryCustomerAddress,
                    cod_amount: Math.round(Number(due)),
                    delivery_status:
                      response.data?.data?.order_status.toLowerCase(),
                    note: deliveryFormData?.note,
                  };
                  try {
                    const courierResponse = await axios.post(
                      `${process.env.REACT_APP_API_URL}steadfast-couriers`,
                      steadFastOrderResponse,
                      {
                        headers: {
                          authorization: `Bearer ${token}`,
                          "Content-Type": "application/json",
                        },
                      }
                    );
                    console.log("📦 Courier order placed:", courierResponse.data);
                    //navigate(`/invoice/${invoice_id}`);
                    onClose();

                  } catch (courierError) {
                    if (courierError.response) {
                      console.error(
                        "Courier Error (response):",
                        courierError.response.data
                      );
                    } else if (courierError.request) {
                      console.error(
                        "Courier Error (no response):",
                        courierError.request
                      );
                    } else {
                      console.error(
                        "Courier Error (setup):",
                        courierError.message
                      );
                    }
                  }
                })
                .catch((error) => {
                  if (error.response) {
                    // Server responded with a status other than 2xx
                    console.error(
                      "🛑 Server responded with an error:",
                      error.response.status
                    );
                    console.error("Error data:", error.response.data);
                  } else if (error.request) {
                    // Request was made but no response received
                    console.error("🛑 No response received:", error.request);
                  } else {
                    // Something else happened while setting up the request
                    console.error("🛑 Error in request setup:", error.message);
                  }
                });
          }
        //----------------------------------------------------PATHAO BLOCK END-------------------------------
        }
      })
      .catch((error) => {
        loadingCallback(false);
        if (error?.response?.status === 401) {
          localStorage.clear();
          localStorage.setItem("token", false);
          // Clear session and local storage
          localStorage.setItem("isPinVerify", false);

          navigate("/login");
        }
      });
  }

  const handleConfirmOrder = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to confirm delivery?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#16a34a", // green-600
      cancelButtonColor: "#9ca3af", // gray-400
      confirmButtonText: "Yes, Confirm",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        handleSubmitOrder();
        Swal.fire({
          title: "Confirmed!",
          text: "Delivery has been confirmed.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
      }
    });
  };

  const handleChange = (field, value) => {
    setDeliveryFormData(prev => ({ ...prev, [field]: value }));
  };

  return ReactDOM.createPortal(
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] px-4">
      <div className="bg-white w-full max-w-xl rounded-lg shadow-lg p-6 relative max-h-[90vh] overflow-y-auto">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-600 hover:text-red-500 text-lg"
        >
          ✕
        </button>

        {/* Modal Content */}
        <h2 className="text-xl font-semibold mb-4">Delivery Details</h2>
        {/* Delivery Method Select */}
        <div
          className="flex items-center justify-center pt-5 gap-3 pb-2"
          // onClick={() => setMethodIndex(0)}
        >
          <ItemSelectBox2
            name="delivery_id"
            options={deliveryList}
            value={deliveryFormData.deliveryId}
            onChange={handleChangeSelect.bind(this, "delivery_id")}
            label="Delivery Method"
            placeholder={deliveryFormData.deliveryName}
            style={{ maxHeight: "300px", overflowY: "scroll", fontSize: "16px" }}
          />
        </div>
        {deliveryFormData?.deliveryName?.toLowerCase() === "pathao" && (
          <div
            className="flex items-center justify-center py-2 gap-3"
            //onClick={() => setMethodIndex(0)}
          >
            <ItemSelectBox2
              name="store_id"
              options={pathaoStores}
              value={pathaoStore?.store_id}
              onChange={handlePathaoStoreChangeSelect.bind(
                this,
                "store_id"
              )}
              label={"Pathao Store"}
              placeholder={pathaoStore?.store_name}
              style={{ maxHeight: "300px", overflowY: "scroll", fontSize: "16px"  }}
            />
          </div>
        )}

        {deliveryFormData?.deliveryName?.toLowerCase() === "pathao" && (
          <div
            className="flex items-center justify-center py-2 gap-3"
            //onClick={() => setMethodIndex(0)}
          >
            <ItemSelectBox2
              name="city_id"
              options={pathaoCities}
              value={pathaoCity?.city_id}
              onChange={handlePathaoCityChangeSelect.bind(
                this,
                "city_id"
              )}
              label={"Pathao City"}
              placeholder={pathaoCity?.city_name}
              style={{ maxHeight: "300px", overflowY: "scroll", fontSize: "16px"  }}
            />
          </div>
        )}

        {deliveryFormData?.deliveryName?.toLowerCase() === "pathao" &&
          pathaoCity.city_id !== "" && (
            <div
              className="flex items-center justify-center py-2 gap-3"
              //onClick={() => setMethodIndex(0)}
            >
              <ItemSelectBox2
                name="zone_id"
                options={pathaoZones}
                value={pathaoZone?.zone_id}
                onChange={handlePathaoZoneChangeSelect.bind(
                  this,
                  "zone_id"
                )}
                label={"Pathao Zone"}
                placeholder={pathaoZone?.zone_name}
                style={{ maxHeight: "300px", overflowY: "scroll", fontSize: "16px"  }}
              />
            </div>
          )}

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Recipient Name
            </label>
            <input
              value={deliveryFormData.deliveryCustomerName}
              onChange={(e) => handleChange("deliveryCustomerName", e.target.value)}
              type="text"
              className="w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 outline-none  text-[16px]"
              placeholder="Enter name"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Delivery Phone
            </label>
            <input
              type="text"
              value={deliveryFormData.deliveryCustomerPhone}
              onChange={(e) => handleChange("deliveryCustomerPhone", e.target.value)}
              className="w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 outline-none  text-[16px]"
              placeholder="01XXXXXXXXX"
            />
            {/* Validation message */}
            {deliveryFormData.deliveryCustomerPhone &&
              !/^01[3-9]\d{8}$/.test(deliveryFormData.deliveryCustomerPhone) && (
                <p className="text-red-500 text-xs mt-1">
                  Please enter a valid BD phone number (e.g., 01XXXXXXXXX)
                </p>
              )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Address
            </label>
            <textarea
              value={deliveryFormData.deliveryCustomerAddress}
              onChange={(e) => handleChange("deliveryCustomerAddress", e.target.value)}
              className="w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 outline-none  text-[16px]"
              placeholder="Enter address"
            ></textarea>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Note
            </label>
            <textarea
              value={deliveryFormData.note}
              onChange={(e) => handleChange("note", e.target.value)}
              className="w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 outline-none  text-[16px]"
              placeholder="Enter Note"
            ></textarea>
          </div>

          <button
            onClick={handleConfirmOrder}
            className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition"
          >
            Confirm Delivery
          </button>
        </div>
      </div>
    </div>,
  document.body
  );
}